import { io } from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
  return io(getBackendUrl(), {
    transports: ["polling", "websocket"],
    pingTimeout: 60000,
    forceNew: true
  });
}

export default connectToSocket;
